import React, { useMemo, useEffect, useRef } from 'react';
import { ColumnRendererFactory, Attributes } from '@leverege/ui-attributes';
import { Toolbar } from '@leverege/ui-plugin';
import S from './Shared.css';
import { jsx as _jsx } from "react/jsx-runtime";
const EMPTY_OBJ = {};
const Filter = /*#__PURE__*/React.memo(FilterComp);
export default function useTable(opts) {
  const {
    model,
    selection,
    pageItems,
    context = EMPTY_OBJ,
    dataViewerId,
    overrides
  } = opts;
  const ovrs = overrides.get(dataViewerId) || EMPTY_OBJ;
  const gridRef = useRef();
  useEffect(() => {
    const items = selection?.items;
    if (items && items.length > 0) {
      const index = pageItems?.findIndex(item => {
        return item?.id === items[0].id;
      });
      if (index !== -1 && gridRef?.current?.scrollToCell) {
        const {
          _renderedRowStartIndex,
          _renderedRowStopIndex
        } = gridRef.current;
        if (index < _renderedRowStartIndex || index > _renderedRowStopIndex) {
          gridRef.current.scrollToCell({
            columnIndex: 0,
            rowIndex: index
          });
        }
      }
    }
  }, [selection, pageItems]);
  const columns = useMemo(() => {
    if (model?.columns) {
      return model.columns.reduce((prev, curr) => {
        const rnd = ColumnRendererFactory.create(curr);
        const ovrWidthKey = `table.colWidth.${curr.id}`;
        const width = ovrs[ovrWidthKey];
        if (rnd != null) {
          const colInfo = rnd.getColumnInfo(context);
          if (width != null) {
            colInfo.width = width;
          }
          const attribute = Attributes.getAttribute(curr.attrName, curr.objectType);
          if (attribute) {
            colInfo.Filter = Filter;
            colInfo.attribute = attribute;
            prev.push(colInfo);
          }
        }
        return prev;
      }, []);
    }
    return [];
  }, [model, ovrs]);
  return {
    columns,
    gridRef
  };
}
function FilterComp(props) {
  const {
    column,
    filters,
    delegate,
    onFilterChange,
    context
  } = props;
  const {
    attribute: attr
  } = column;
  const canFilter = attr.getOption?.('filterable');
  const canSort = attr.getOption?.('sortable');
  if (!canFilter && !canSort) {
    return null;
  }
  const isNumeric = attr?.valueType !== 'string' && attr?.valueType !== 'resourceEnum' && attr?.valueType !== 'enum' && attr?.valueType !== 'parentRelationship' && attr?.valueType !== 'boolean';
  const isTimestamp = attr?.valueType === 'timestamp';
  const isBoolean = attr?.valueType === 'boolean';
  const matchContext = {
    use: 'tableColumnHeaderActionBar',
    client: 'TableDataViewer',
    objectType: attr.objectType
  };
  const cxt = {
    attribute: attr,
    objectType: attr.objectType,
    isNumeric,
    isTimestamp,
    isBoolean,
    canSort,
    canFilter,
    filters,
    delegate,
    onFilterChange,
    relationship: delegate.relationship,
    clientProps: context.clientProps
  };
  return /*#__PURE__*/_jsx(Toolbar, {
    variant: "actionBar",
    className: S.toolbar,
    prefer: "icon",
    matchContext: matchContext,
    context: cxt
  });
}